<script setup>

import FadeTransition from "@/components/transitions/FadeTransition.vue";
import { useCreateWebsite } from "@/composables/website/v2/useCreateWebsite.js";

const { steps, currentStep } = useCreateWebsite();
</script>

<template>
  <FadeTransition>
    <component
      :is="steps[currentStep]"
    />
  </FadeTransition>
</template>
